import React from 'react';
import { Element } from 'react-scroll';
import { Box } from '@mui/material';
import Navbar from '../components/Website/Navbar';
import HeroSection from '../components/Website/HeroSection';
import ServicesSection from '../components/Website/ServicesSection';
import TechnologiesSection from '../components/Website/TechnologiesSection';
import AgileMethodology from '../components/Website/AgileMethodology';
import WhyChooseUs from '../components/Website/WhyChooseUs';
import AboutSection from '../components/Website/AboutSection';
import ContactSection from '../components/Website/ContactSection';
import Footer from '../components/Website/Footer';
import Staff from '../components/Website/StaffSection';
import PortfolioSection from '../components/Website/PortfolioSection';
import ScrollReveal from '../components/Animation/ScrollReveal';

const HomePage: React.FC = () => {
  return (
    <Box>
      <Navbar />
      
      <Element name="home">
        <HeroSection />
      </Element>
      
      <Element name="services">
        <ScrollReveal direction="up" duration={0.6}>
          <ServicesSection />
        </ScrollReveal>
      </Element>
      
      <Element name="technologies">
        <ScrollReveal direction="up" duration={0.6} delay={0.1}>
          <TechnologiesSection />
        </ScrollReveal>
      </Element>
      
      {/* Agile Methodology Section - Added after Technologies */}
      <Element name="agile-methodology">
        <ScrollReveal direction="up" duration={0.6} delay={0.15}>
          <AgileMethodology />
        </ScrollReveal>
      </Element>
      
      <Element name="why-choose-us">
        <ScrollReveal direction="up" duration={0.6} delay={0.2}>
          <WhyChooseUs />
        </ScrollReveal>
      </Element>
      
      <Element name="about">
        <ScrollReveal direction="up" duration={0.6} delay={0.3}>
          <AboutSection />
        </ScrollReveal>
      </Element>
      
      <Element name="portfolio">
        <ScrollReveal direction="up" duration={0.6} delay={0.4}>
          <PortfolioSection />
        </ScrollReveal>
      </Element>
      
      <Element name="staff">
        <ScrollReveal direction="up" duration={0.6} delay={0.5}>
          <Staff />
        </ScrollReveal>
      </Element>
      
      <Element name="contact">
        <ScrollReveal direction="up" duration={0.6} delay={0.6}>
          <ContactSection />
        </ScrollReveal>
      </Element>
      
      <Footer />
    </Box>
  );
};

export default HomePage;